export default "__VITE_ASSET__DvUL1Oyn__"